import { apiSlice } from "../../Api/apiSlice";

const quizzesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all quizzes records
    getQuizzes: builder.query({
      query: () => "/quizzes",
    }),
    // Get one specific Quiz record
    getQuiz: builder.query({
      query: (qId) => `/quizzes/${qId}`,
    }),
    // Add new Quizzes
    addQuiz: builder.mutation({
      query: (data) => ({
        url: "/quizzes",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            quizzesApi.util.updateQueryData(
              "getQuizzes",
              undefined,
              (draft) => {
                draft.push(data);
              }
            )
          );
        } catch (error) {
          console.log("Quizzes POST Error: ", error.message);
        }
      },
    }),
    // Edit Quiz
    editQuiz: builder.mutation({
      query: ({ data, id }) => ({
        url: `/quizzes/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [{ type: "quiz", id: arg.id }],
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            quizzesApi.util.updateQueryData(
              "getQuizzes",
              undefined,
              (draft) => {
                const vdo = draft.find((v) => v.id == data.id);
                Object.assign(vdo, { ...data });
              }
            )
          );
        } catch (error) {
          console.log("Error Quiz edit::", error.message);
        }
      },
    }),
    // Delete Quiz
    deleteQuiz: builder.mutation({
      query: (vId) => ({
        url: `/quizzes/${vId}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // Optimistic cache update Start
        const patchResult = dispatch(
          quizzesApi.util.updateQueryData("getQuizzes", undefined, (draft) => {
            return (draft = draft.filter((v) => v.id != arg));
          })
        );
        queryFulfilled.catch(patchResult.undo);
        // Optimistic cache update End
      },
    }),
  }),
});

export const {
  useAddQuizMutation,
  useDeleteQuizMutation,
  useEditQuizMutation,
  useGetQuizQuery,
  useGetQuizzesQuery,
} = quizzesApi;
